/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Crisp_DescriptionInputs */

const en_admin_settings_groups_crisp_description = /** @type {(inputs: Admin_Settings_Groups_Crisp_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crisp live chat widget`)
};

/**
* | output |
* | --- |
* | "Crisp live chat widget" |
*
* @param {Admin_Settings_Groups_Crisp_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_crisp_description = /** @type {((inputs?: Admin_Settings_Groups_Crisp_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Crisp_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_crisp_description(inputs)
});
export { admin_settings_groups_crisp_description as "admin.settings.groups.crisp.description" }